import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import propertyService from '../../services/property';

const initialState = {
  loading: false,
  propertyValues: [],
  error: '',
  meta: {},
};

export const fetchPropertyValues = createAsyncThunk(
  'property/fetchPropertyValues',
  (params = {}) => {
    return propertyService.getAllValues(params).then((res) => res);
  }
);

const propertyValueSlice = createSlice({
  name: 'propertyValue',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPropertyValues.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPropertyValues.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.propertyValues = Array.isArray(payload?.data) ? payload.data : (payload?.data?.data ?? []);
      state.meta = payload?.meta ?? payload?.pagination ?? {};
      state.error = '';
    });
    builder.addCase(fetchPropertyValues.rejected, (state, action) => {
      state.loading = false;
      state.propertyValues = [];
      state.meta = {};
      state.error = action.error.message;
    });
  },
});

export default propertyValueSlice.reducer;
